import { useEffect } from 'react'
import Template from '../components/Template'
import {Container, Alert, Button} from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import {getOneDocument, deleteDocument} from '../actions/documentActions'
import Loader from '../components/Loader'

const renderFile = file => {
    const url = `/uploads/${file.name}`
    if(file.mimetype && file.mimetype.includes('image')) {
        return <img src={url} alt={file.originalName || 'مرفق'} />
    }
    if(file.mimetype && file.mimetype.includes('video')) {
        return <video controls src={url}></video>
    }
    return <a href={url} target='_blank' rel='noreferrer'>
        <i className='far fa-file-pdf'></i>
        {file.originalName || 'عرض الملف'}
    </a>
}

const DocumentInfo = () => {
    const dispatch = useDispatch()
    const {loading, error, document} = useSelector(state => state.document)
    const {user:{data}} = useSelector(state => state.login)
    const {loading:loading_r, error:error_r, message} = useSelector(state => state.removeDocument)
    const {id} = useParams()

    const deleteDocumentHandler = _ => {
        const confirm = window.confirm('هل أنت متأكد من حذف الوثيقة؟')
        if(confirm) dispatch(deleteDocument(id))
    }

    useEffect(() => {
        dispatch(getOneDocument(id))
    },[dispatch, id])

    return (
        <Template>
            <Container>
                {loading ? <Loader/>
                :error ? <Alert variant='danger'>{error}</Alert>
                :document && <div className="documents__wrapper">
                    <article className="documents__article">
                    {loading_r ? <Loader/>
                    :error_r ? <Alert style={{margin:'1rem 0'}} variant='danger'>{error_r}</Alert>
                    :message && <Alert style={{margin:'1rem 0'}} variant='success'>{message}</Alert>}
                    {data && (data.isCoAdmin || data.isAdmin) && <Button variant='danger'
                    style={{margin:'2rem 0'}}
                    onClick={deleteDocumentHandler}>
                        حذف الوثيقة
                    </Button>}
                        <h2>{document.title}</h2>
                        <p>{document.description}</p>
                        {document.files && document.files.length > 0 && <div className='documents__files'>
                            {document.files.map(file => (
                                <div className='documents__file' key={file.name}>
                                    {renderFile(file)}
                                </div>
                            ))}
                        </div>}
                    </article>
                </div>}
            </Container>
        </Template>
    )
}

export default DocumentInfo
